// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"fef1f105","473":"597337e6","654":"b9979849","867":"7bf78dfc","955":"c4025c25"}[chunkId] + ".chunk.js";
};